import { RefDataState, SchoolsByCountry } from "app/pages/AgentPricing/modules/RefData/state";
import { Action, ActionType } from "app/pages/AgentPricing/actionTypes";
import { Centre, School, Country } from "app/shared/model";

const startingState : RefDataState = {
    agent: {
        id: '',
        name: 'Unknown agent'
    },
    countries: [],
    schools: [],
    products: [],
    fees: [],
    offices: [],
    schoolsByCountry: [],
    hasNoCommissionGroup: false,
    hasExternalAgentData: true
}

export function viewPageReducer(state: RefDataState|undefined, action: Action) : RefDataState {
    if (!state) {
        return startingState;
    }

    switch(action.type) {
        case ActionType.ViewPageLoaded:
            return {
                agent: {
                    id: action.data.id,
                    name: action.data.name,
                    status: action.data.status
                },
                countries: action.data.countries,
                schools: action.data.schools,
                products: action.data.products,
                fees: action.data.fees,
                offices: action.data.offices ?? [],
                schoolsByCountry: [],
                hasNoCommissionGroup: action.data.hasNoCommissionGroup,
                hasExternalAgentData: action.data.hasExternalAgentData ?? true
            };

        case ActionType.EditPageLoaded:
            return {
                agent: {
                    id: action.data.id,
                    name: action.data.name,
                    groupId: action.data.groupId,
                    status: action.data.status
                },
                countries: action.data.countries,
                schools: action.data.schools,
                schoolsByCountry: groupSchoolsByCountry(action.data.schools, action.data.centres, action.data.countries),
                products: [],
                fees: [],
                offices: [],
                hasNoCommissionGroup: action.data.hasNoCommissionGroup,
                hasExternalAgentData: action.data.hasExternalAgentData ?? true
            };

        default: 
            return state; 
    }
}

function groupSchoolsByCountry(schools: School[], centres: Centre[], countries: Country[]) : SchoolsByCountry[] {
    const groupResult : SchoolsByCountry[] = [];

    const centreMap = new Map<string, Centre>();
    centres.forEach(c => centreMap.set(c.code, c));

    schools.forEach(s => {
        const centre = centreMap.get(s.centreCode);
        if (!centre)
            return;

        let countryRec = groupResult.find(x => x.countryCode === centre.countryCode);
        if (!countryRec) {
            const country = countries.find(c => c.id === centre.countryCode);
            countryRec = {
                countryCode: centre.countryCode,
                countryName: country ? country.name : 'Other',
                schools: []
            };
            groupResult.push(countryRec);
        }

        countryRec.schools.push(s);
    })

    groupResult.sort((a, b) => a.countryName.localeCompare(b.countryName));

    return groupResult;
}